import { Controller } from "@hotwired/stimulus";
import confetti from "canvas-confetti";

export default class ConfettiController extends Controller {
  connect() {
    confetti();
  }
}
